/* global LOGOS, HOME_TITLE, HOME_URL */

const SearchHeader = {
  name: 'SearchHeader',
  template: `
    <div class="header__top">
      <div class="header-logos">
        <a :href="HOME_URL" :title="HOME_TITLE" class="header-logos__maistra">
          <picture>
            <source media="(min-width: 992px)" :srcset="LOGOS.maistra.desktop">
            <img :src="LOGOS.maistra.mobile" :alt="HOME_TITLE" width="48" height="48">
          </picture>
        </a>
      </div>
      <div class="header__icons">
        <button class="button button--blank" @click="$emit('close')" :title="$t('close')">
          <span class="hide-sm-down">{{ $t('close') }}</span>
          <i class="icon-close"></i>
        </button>
      </div>
    </div>
  `,
  setup () {
    return {
      LOGOS,
      HOME_TITLE,
      HOME_URL,
    }
  },
}

export default SearchHeader
